import React from 'react';
import { cloneDeep } from 'lodash';
import { assign } from 'xstate';
import { IntlShape } from 'react-intl';
import { Box, Button } from '@mui/material';

import { BaseComponent } from '../Component';
import { MachineContext } from '../../MachineContext';
import { translateWithFallback } from '../../util';

export interface DownloadButtonComponent extends BaseComponent {
  type: 'downloadButton';
  props: DownloadButtonProps;
}
export interface DownloadButtonProps {
  buttonText: string;
  resolvedSrc: string;
  src?: string;
  assetid?: string;
}

//
// forceDownload appends a virtual element, starts download and removes element again
//
export const forceDownload = (url: string, filename?: string) => {
  // do nothing if the url is not provided
  if (!url || url.trim() === '') return;
  // if url is provided, created a fake download link, click it and remove it.
  var a = document.createElement('a');
  a.download = filename ?? url.split('/').pop() ?? 'evoachdownload';
  a.href = url;
  // new window/tab in case that the browser is not downloading (e.g. PDF)
  a.target = '_blank';
  // noreferrer to avoid security issues
  a.rel = 'noreferrer';
  // For Firefox https://stackoverflow.com/a/32226068
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const DownloadButton: React.FC<DownloadButtonProps> = ({
  buttonText,
  resolvedSrc,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'space-between',
        gap: '0.5rem',
      }}
    >
      <Button onClick={() => forceDownload(resolvedSrc)}>{buttonText}</Button>
    </Box>
  );
};

export const renderDownloadButtonAction = (intl: IntlShape) => {
  return assign((context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    const payload = actionMetadata.action.payload;

    newContext.widgetData.push({
      type: 'downloadButton',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        buttonText: translateWithFallback(intl, payload.buttonText),
        resolvedSrc: payload.resolvedsrc,
        src: payload.src,
        assetid: payload.assetid,
      },
    });
    return newContext;
  });
};
